import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityDataAccessSearch } from '@api/data-security';

export const getCoreDataSecurityDataAccessSearchSlice = createGetAsyncSlice({
	name: 'CoreDataSecurityDataAccessSearch',
	receive: true,
	request: false,
	requestHandler: getDataSecurityDataAccessSearch,
	retainDataOnRequest: true
});
